import { Link } from 'react-router-dom';
import { AjkMap } from './ui/AjkMap.tsx';
import { SectionTitle, SiteLayout } from './ui/site.tsx';

const COMPONENTS = [
  { n: '01', title: 'Smart health kiosk', ur: 'صحت کیوسک', body: 'At BHUs, RHCs and hospital OPDs. Identifies the patient by CNIC, card or visit code, measures blood pressure, pulse, oxygen, temperature, height and weight, takes symptoms in Urdu and prints a summary — run by the patient or a health worker.', to: '/kiosk', cta: 'Open the kiosk' },
  { n: '02', title: 'Telemedicine', ur: 'ٹیلی میڈیسن', body: 'Doctors of the Department’s pool, including the AJK Medical College specialists, see the kiosk vitals and coded Urdu intake before the call; video with audio and chat fallback; e-prescription with safety checks.', to: '/clinician', cta: 'Open the doctor’s workspace' },
  { n: '03', title: 'Government dashboard', ur: 'سرکاری ڈیش بورڈ', body: 'Facility, district and program views of screenings, risk flags, teleconsults and device health; DHIS2 export; a printable monthly brief for the Minister of Health.', to: '/dashboard', cta: 'Open the dashboard' },
];

export function Home() {
  return (
    <SiteLayout>
      <section className="band-dark hero">
        <div className="wrap">
          <div className="gov-kicker">Proposal to the Department of Health · Government of AJK</div>
          <h1>AJK Smart Health <span className="gold">Kiosk Program</span></h1>
          <div className="hero-ur" lang="ur" dir="rtl">آزاد کشمیر سمارٹ ہیلتھ کیوسک پروگرام</div>
          <p className="lede">
            AI-assisted health screening, built-in telemedicine and a live government dashboard for Basic Health Units, Rural Health Centres and
            hospitals across all ten districts of Azad Jammu &amp; Kashmir — starting with a 25-kiosk, 90-day pilot and a measured pathway to 100 kiosks.
          </p>
          <div className="hero-actions">
            <Link to="/proposal" className="btn btn-gold btn-lg">Read the proposal</Link>
            <Link to="/scope" className="btn btn-outline-light btn-lg">Program scope</Link>
            <Link to="/ministry" className="btn btn-outline-light btn-lg">How the Ministry runs it</Link>
          </div>
          <div className="stat-cards">
            <div className="stat-card"><div className="v">589</div><div className="l">public health facilities</div></div>
            <div className="stat-card"><div className="v">4.4M+</div><div className="l">people · 88% rural</div></div>
            <div className="stat-card"><div className="v">10</div><div className="l">districts · 3 divisions</div></div>
            <div className="stat-card"><div className="v">25 → 100</div><div className="l">kiosks · pilot to program</div></div>
          </div>
        </div>
      </section>

      <section className="band">
        <div className="wrap">
          <SectionTitle kicker="The program">Three components, one government service</SectionTitle>
          <div className="card-grid">
            {COMPONENTS.map((c) => (
              <Link key={c.n} to={c.to} className="gcard">
                <div className="num">COMPONENT {c.n}</div>
                <h3>{c.title} <span lang="ur" style={{ fontFamily: 'var(--font-ur)', color: 'var(--gov-gold)', fontWeight: 400 }}>· {c.ur}</span></h3>
                <p>{c.body}</p>
                <div className="go">{c.cta} →</div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="band band-ivory2">
        <div className="wrap">
          <SectionTitle kicker="A patient visit">From the door to a doctor in minutes</SectionTitle>
          <div className="card-grid">
            {[
              ['Identify', 'CNIC, patient card or the QR code of a previous slip. Only a masked identity is ever shown.'],
              ['Measure', 'Guided, quality-checked vitals in under five minutes, with spoken Urdu prompts.'],
              ['Triage', 'Urgent readings are flagged to staff and cannot be dismissed by the patient.'],
              ['Consult', 'One tap to a doctor who already has the vitals and symptoms; prescription returns to the kiosk.'],
              ['Record', 'Every visit is a digital record owned by the Health Department; the dashboard updates live.'],
            ].map(([t, b], i) => (
              <div key={t} className="gcard gold"><div className="num">STEP {i + 1}</div><h3>{t}</h3><p>{b}</p></div>
            ))}
          </div>
        </div>
      </section>

      <section className="band">
        <div className="wrap">
          <SectionTitle kicker="Where the program operates">Hospitals of Azad Jammu &amp; Kashmir</SectionTitle>
          <AjkMap title="AJK hospital network" />
        </div>
      </section>

      <section className="band band-dark">
        <div className="wrap">
          <SectionTitle kicker="Try it">Working software, ready for the Department to test</SectionTitle>
          <p className="lede">Every surface runs live on synthetic data — no real patient information. Demo accounts and kiosk keys are shown on each sign-in screen.</p>
          <div className="hero-actions">
            <Link to="/kiosk" className="btn btn-gold btn-lg">Health kiosk</Link>
            <Link to="/clinician" className="btn btn-outline-light btn-lg">Telemedicine</Link>
            <Link to="/dashboard" className="btn btn-outline-light btn-lg">Dashboard</Link>
            <Link to="/display" className="btn btn-outline-light btn-lg">Waiting-room display</Link>
            <Link to="/brief" className="btn btn-outline-light btn-lg">Minister’s monthly brief</Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
